import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Dashboard.css';
import NavBar from '../components/EditAnnualLeaveRequest/NavBar';
import EditAnnualLeaveRequestContent from '../components/EditAnnualLeaveRequest/EditAnnualLeaveRequestContent';
import { API_URL, API_username, API_password } from '../utils/api';

function EditAnnualLeaveRequest() {
	const location = useLocation();
    const request = location.state?.request; 
	useEffect(() => {
		fetchAnnualRequestData();
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
    const [requestData, setRequestData] = useState({
        Action: "edit",
        UID: request.UID,
        StartDate: "",
        EndDate: "",
        AttachedFiles: [],
    });

	const fetchAnnualRequestData = () => {
		setLoading(true);
		let apiUrl = `${API_URL}/lk?method=FetchAnnualRequestData&inbody=1`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			},
			body: JSON.stringify({
				UID: request.UID
			})
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				if(response.statusText === 'Session not found') {
					message.error('Сессия не найдена, авторизуйтесь заново!');
					navigate('/logout');
				} else {
					message.error('Метод не найден!');
				}
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if(data !== "error") {
				requestData.StartDate = data.StartDate;
				requestData.EndDate = data.EndDate;
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
	}
		
	const manageAnnualLeaveRequest = (action) => {
		if(requestData.StartDate === "" || requestData.EndDate === "") {
			message.info('Заполните период отпуска корректно!');
		} else if(action == "edit" && requestData.AttachedFiles.length === 0) {
			message.info('Прикрепление подписанного непосредственным руководителем скана заявления обязательно!');
		} else {
			setLoading(true);
			let apiUrl = `${API_URL}/lk?method=ManageAnnualLeaveRequest&inbody=1`;
			let sessionId = localStorage.getItem("SessionId")
			requestData.Action = action; 
			fetch(apiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
					'sessionid': sessionId
				},
				body: JSON.stringify(requestData)
			})
			.then(response => {
				if (response.status === 200) {
					switch(action) {
						case 'edit':
							message.success('Заявление успешно изменено!');
							break;
						case 'delete':
							message.success('Заявление успешно удалено!');
							break;
					}
					navigate('/requests');
					return "success";
				} else if (response.status === 202) {
					message.error('Сервер на данный момент перегружен!');
					return "error";
				} else if (response.status === 404) {
					console.log(response.statusText)
					if(response.statusText === 'Session not found') {
						message.error('Сессия не найдена, авторизуйтесь заново!');
						navigate('/logout');
					} else if(response.statusText === "The document is already opened by the responsible HR") {
						message.error('Заявление уже рассамтривается ответственным HR, редактирование или удаление заявления невозможно!');
					} else {
						message.error('Метод не найден!');
					}
					return "error";
				} else {
					message.error('Произошла ошибка при отправке запроса!');
					return "error";
				}
			})
			.catch(error => {
				message.error('Ошибка: ' + error.message);
			}).finally(() => {
				setLoading(false);
			});
		}
	}

	return (
		<div>
			<Helmet>
				<title>Изменение заявления на ежегодный отпуск - Личный кабинет Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content' style={{ padding: 0 }}>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
					<div className='manage-request-content'>
						<EditAnnualLeaveRequestContent requestData={requestData} setRequestData={setRequestData} request={request} />
						<Button onClick={() => manageAnnualLeaveRequest('edit')} style={{ marginTop: '8px' }}>Изменить</Button>
						<Button onClick={() => manageAnnualLeaveRequest('delete')} style={{ marginLeft: '8px' }}>Удалить</Button>
						<Button onClick={() => navigate('/requests')} style={{ marginLeft: '8px' }}>Назад</Button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EditAnnualLeaveRequest;
